import http from './http'

export const post = (url: string, params: any) =>
  http.request({
    url: url,
    method: 'post',
    data: params
  })
export const put = (url: string, params: any) =>
  http.request({
    url: url,
    method: 'post',
    data: params
  })
export const get = (url: string, params: any) =>
  http.request({
    url: url,
    method: 'get',
    params: params
  })
export const del = (url: string, params: any) =>
  http.request({
    url: url,
    method: 'delete',
    params: params
  })